import React from 'react'
import { createRoot } from 'react-dom/client'
import { AppShell } from '@buffer-mono/app-shell'

import { APIGatewayProvider } from '~/app/providers'
import App from '~/app/App'

/**
 *
 */

// Commenting out the mock provider for now since it is not set up to work in Vite yet
// const Provider = env.VITE_NODE_ENV === 'mocked' ? MockedProvider : APIGatewayProvider
const Provider = APIGatewayProvider

const AppWrapper = (): JSX.Element => {
  return <App />
}

const navigator = document.getElementById('navigator')
const hideNavigation = !!navigator?.getAttribute('data-hide-navigation')
const hideBanners = !!navigator?.getAttribute('data-hide-banners')

const rootElement = document.getElementById('root')
if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <AppShell hideNavigation={hideNavigation} hideBanners={hideBanners} />
      <Provider>
        <AppWrapper />
      </Provider>
    </React.StrictMode>,
  )
}
